// Password Security Utility for Frontend Validation
// Matches server-side validation in /common/utils/password-security.js

class PasswordSecurity {
  constructor() {
    this.policies = {
      minLength: 12,
      requireUppercase: true,
      requireLowercase: false,
      requireNumbers: true,
      requireSymbols: true,
    };
  }

  validatePassword(password) {
    const result = {
      isValid: true,
      errors: [],
      warnings: [],
      strength: 0,
    };

    if (!password || typeof password !== "string") {
      result.isValid = false;
      result.errors.push("Password is required");
      return result;
    }

    // Check minimum length
    if (password.length < this.policies.minLength) {
      result.isValid = false;
      result.errors.push(
        `Password must be at least ${this.policies.minLength} characters long`
      );
    } else {
      result.strength += 20;
    }

    // Check for uppercase letters
    if (this.policies.requireUppercase && !/[A-Z]/.test(password)) {
      result.isValid = false;
      result.errors.push("Password must contain at least one uppercase letter");
    } else if (/[A-Z]/.test(password)) {
      result.strength += 15;
    }

    // Lowercase is not mandatory anymore

    // Check for numbers
    if (this.policies.requireNumbers && !/[0-9]/.test(password)) {
      result.isValid = false;
      result.errors.push("Password must contain at least one number");
    } else if (/[0-9]/.test(password)) {
      result.strength += 15;
    }

    // Check for special characters
    if (
      this.policies.requireSymbols &&
      !/[!@#$%^&*(),.?":{}|<>]/.test(password)
    ) {
      result.isValid = false;
      result.errors.push(
        'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)'
      );
    } else if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      result.strength += 15;
    }

    // Strength calculation: 25% per satisfied rule (length, uppercase, number, symbol)
    let strengthScore = 0;
    if (password.length >= this.policies.minLength) strengthScore += 25;
    if (/[A-Z]/.test(password)) strengthScore += 25;
    if (/[0-9]/.test(password)) strengthScore += 25;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) strengthScore += 25;
    result.strength = strengthScore;

    return result;
  }

  // Get strength description
  getStrengthDescription(strength) {
    if (strength < 30) return "Very Weak";
    if (strength < 50) return "Weak";
    if (strength < 70) return "Fair";
    if (strength < 90) return "Strong";
    return "Very Strong";
  }

  // Get strength color for UI
  getStrengthColor(strength) {
    if (strength < 30) return "#f44336"; // red
    if (strength < 50) return "#ff9800"; // orange
    if (strength < 70) return "#ffeb3b"; // yellow
    if (strength < 90) return "#4caf50"; // green
    return "#2196f3"; // blue
  }
}

export default new PasswordSecurity();
